"use strict";

const prevItemDataHotFix = Symbol('prevItemDataHotFix');

class TemplateItemCtrl {

	constructor($mdDialog, $scope, $rootScope, $http, $state, TemplateItem, $stateParams, bladesManager, Contact, $timeout, $transitions) {
		this.$mdDialog = $mdDialog;
		this.$http = $http;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.duration = 30;
		this.customFieldsRaw = [];
		this.customFields = {};
		this.formdata = {
			duration: this.duration,
			tags: [],
			contacts: []
		};
		this._TemplateItem = TemplateItem;
		this.bladesManager = bladesManager;
		this.tagText = '';
		this.searchText = '';
		this.Contact = Contact;
		this.$timeout = $timeout;

		this.modelTypes = [];
		this.contactSearchData = [''];
		this.$scope.$on('item_contact_updated', this.contactUpdate.bind(this));

		this.unregisterStateChangeStart = $transitions.onStart({}, this.stateChangeStart.bind(this));
		$scope.$on('$destroy', () => {
			this.unregisterStateChangeStart();
		});

		if (window[prevItemDataHotFix]) {
			const [itemId, patchData] = window[prevItemDataHotFix] || [];
			delete window[prevItemDataHotFix];

			if (itemId === this.$stateParams.item_id) {
				angular.extend(this.formdata, patchData);
			}
		}

		$http.get('modeltypes/').then((response) => {
			this.modelTypes = response.data.item;
		});

		this.getModelTypes().then(() => {
			if (this.customFieldsRaw.length < 2) {
				this.formdata.model_type_id = this.customFieldsRaw[0].id;
			}

			if ($stateParams.item_data) {
				angular.extend(this.formdata, $stateParams.item_data);

			} else if ($stateParams.item_id && $stateParams.item_id != 0) {
				this._TemplateItem.get({id: $stateParams.item_id}, (data) => {
					angular.extend(this.formdata, data);
				});
			} else {
				$http.get('/stationsettings/settings/default_duration').then(result => {
					if (result.data) {
						this.duration = parseInt(result.data);
						this.formdata.duration = parseInt(result.data);
					}
				});
				this.formdata.model_type_id = this.customFieldsRaw[0].id;
			}

		});

	}

    onContactSelect () {
        this.$scope.searchText = ''
        this.contactAddToItem(this.selectedContact)
        this.contactBlur()
    }

	stateChangeStart(transition) {

		let to = transition.to();
		let from = transition.from();
		let toParams = transition.params();

		if (!from.name === 'template.update.item.contact' && to.name === 'template.update.item' && !this.warned) {
			if (this.$scope.templateItemFormBase.$dirty) {
				transition.abort();

				this.$mdDialog.show({
					controller: 'RejectDialogCtrl',
					templateUrl: "confirmRejectDailog.ngTemplate",
					parent: angular.element(document.querySelector('#popupContainer')),
					clickOutsideToClose: true
				}).then(() => {
					this.$state.go(to, toParams);
				}, () => {
					this.warned = false;
				});
			}

		} else if (/^template\.update\.item/.test(to.name)) {
			window[prevItemDataHotFix] = [
				this.$stateParams.item_id,
				angular.copy(this.formdata),
			];
		}
	}


	getModelTypes() {
		return this.$http.get('/modeltypes/item', {cache: true}).then((response) => {
			this.customFieldsRaw = response.data.item;
			response.data.item.forEach((data) => {
				this.customFields[data.id] = data.fields;
			});
			return response.data;
		});
	}


	//this date transform the custom date to 'new Date' so it can be re-used
	makeDate(date) {
		return date ? new Date(date) : new Date();
	}

	goBack() {
		delete window[prevItemDataHotFix];
		this.$state.go('template.update');
	}

	cancel() {
        this.$state.go('^');

	}


	save($valid, dontGo) {
		if (!this.itemIsValid()) {
			return;
		}

		if (!this.formdata.recurring) {
			this.formdata.title = "";
			this.formdata.field_values = null;
			this.formdata.details = null;
		}

		for (const modelType of this.modelTypes) {
			if (modelType.id === this.formdata.model_type_id) {
				this.formdata.model_type = modelType;
				break;
			}
		}

		this.$rootScope.$broadcast('template_item_created', this.formdata);
		this.formdata = {duration: this.duration};

		if (!dontGo) {
			this.goBack();
		}
	}


	itemIsValid() {
		if (this.$scope.templateItemFormRecurring.$valid) {
			if (this.repeating_item) {
				return this.$scope.templateItemFormRecurring.$valid && this.$scope.templateItemFormCustomFields.$valid;
			}
			return true;
		}

		return false;
	}


	tagSearch(query) {

		return this.$http.get('/tags/search/' + encodeURIComponent(query)).then(result => {
			return result.data;
		});
	}


	contactSearch(query) {
		if (!query) {
			return [{add: true}];
		} else {
			return this.$http.get('/contacts/search/' + encodeURIComponent(query)).then(result => {
				let data = result.data;
				data.push({add: true});

				return data;
			});
		}
	}


	contactBlur() {
		let input = angular.element(document.querySelector('.contact-autocomplete-container md-autocomplete input'));
		input.blur();
	}


	contactAddToItem(contact) {

		if (contact) {

			if (contact.add) {
				this.contactCreate();
				return;
			}

			if (!this.formdata.contacts) {
				this.formdata.contacts = [];
			}

			this.formdata.contacts.push(contact);
			//Clear contact search suggest
			this.$timeout(() => {
				this.selectedContact = null;
				this.searchTextContact = null;
			}, 250);

		}
	}


	contactOpenBlade(id) {
		let contactState = 'template.update.item.contact';
		if (_.startsWith(this.$state.current.name, contactState)) {
			// this.$state.go('^');

			setTimeout(() => {
				this.$state.go(contactState, {
					contactId: id,
				});
			}, 400);//we have to wait 400ms for the delete animation of onExit that we cant cancel
		} else {

			// if (this.$state.is('template.update.item.contact')) {
			//     this.$state.go('^');
			// }

			this.$state.go(contactState, {
				contactId: id
			});
		}
	}


	contactCreate() {

		//clear autocomplete
		this.$scope.selectedOption = undefined;
		this.$scope.searchText = '';
		this.$scope.$$childTail.searchText = '';

		this.Contact.save({}, (data) => {
			let nextState = this.$state.is('template.update.item.contact') ? '.' : '.contact';

			// if (this.$state.is('template.update.item.contact')) {
			//     this.$state.go('^');
			// }

			this.$state.go(nextState, {
				contactId: data.id,
				create: true
			});
		});
	}


	contactUpdate(ev, data) {

		if (data.hasOwnProperty('id')) {
			let existing_item = this.formdata.contacts.filter(function (contact) {
				return data.id == contact.id;
			})[0];

			if (existing_item) {
				angular.extend(existing_item, data);
			} else {
				this.formdata.contacts.push(data);
			}
		}
	}


	contactDelete(ev, index) {
		ev.preventDefault();
		this.formdata.contacts.splice(index, 1);
	}


}

TemplateItemCtrl.$inject = ['$mdDialog', '$scope', '$rootScope', '$http', '$state', 'TemplateItem', '$stateParams', 'bladesManager', 'Contact', '$timeout', '$transitions'];

module.exports = TemplateItemCtrl;
